import {
  client,
  getAccessToken,
  getServiceHeaders,
  getServiceUrl,
  handleClientError,
  ResponseCallback
} from './'

/**
 *
 * @param path path to endpoint (e.g. /users/)
 * @param body Body of type I (can be any input)
 * @returns promise ServiceResponse <R>
 */
export const get = async <O>({
  path,
  query = {},
  token = getAccessToken(),
  headers,
  respCb,
  text,
  includeHeaders = false
}: {
  path: string
  query?: { [k: string]: string | number }
  token?: string
  headers?: HeadersInit
  respCb?: ResponseCallback<O>
  text?: boolean
  includeHeaders?: boolean
}): Promise<O> => {
  try {
    return client<null, O>({
      url: getServiceUrl(path, query),
      method: 'GET',
      headers: getServiceHeaders(token, headers),
      respCb,
      text,
      includeHeaders
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    throw handleClientError(e)
  }
}
